const translations = {
    cancel: 'Cancel',
    droneMakeLabel: 'Drone make',
    droneMakePlaceholder: 'Select a drone make',
    save: 'Upload',
    saveError: 'Failed to upload flights. Please try again.',
    saveErrorConflict: 'A flight with the same data already exists.',
    saveErrorUpload: 'One or more files failed to upload.',
    saving: 'Uploading…',
    title: 'Upload Flights'
};

export default translations;
